/* Product page: options and joint picker -> variant, gallery, add to cart (with "complete the setup" add-ons). */
(function () {
  'use strict';

  /* "14mm Male 90" -> { size: '14', type: 'male', angle: '90' }. Returns null when a value doesn't read as a joint. */
  function parseJoint(value) {
    var out = { size: '', type: '', angle: '' }, rest = 0;
    /* notes the store adds to some values: "(clearance)", "11(special)mm", "*SPECIAL SIZE" */
    String(value).replace(/\([^)]*\)/g, '').replace(/\*.*$/, '').replace(/[,/]/g, ' ').split(/\s+/).forEach(function (w) {
      var lw = w.toLowerCase().trim(); if (!lw) return;
      var n = lw.replace(/mm|°|deg(rees)?/g, '');
      if (/mm$/.test(lw) && /^\d+(\.\d+)?$/.test(n)) out.size = n;
      else if (lw === 'male' || lw === 'm') out.type = 'male';
      else if (lw === 'female' || lw === 'f') out.type = 'female';
      else if (/^\d+(\.\d+)?$/.test(n)) { if (out.size) out.angle = n; else out.size = n; }
      else rest++;
    });
    return out.size && !rest ? out : null;
  }
  var DIMS = ['size', 'type', 'angle'];

  class HeProduct extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-product-json]');
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      var rules = this.querySelector('[data-qty-rules]');
      try { this.qtyRules = rules ? JSON.parse(rules.textContent) : {}; } catch (ex) { this.qtyRules = {}; }
      this.section = this.dataset.section;
      this.jointIndex = parseInt(this.dataset.jointIndex, 10);
      this.form = this.querySelector('[data-product-form]');
      this.strings = (window.theme && window.theme.strings) || {};

      this.buildJointSplit();
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.onPageShow = function (e) { if (e.persisted) this.adding = false; }.bind(this);
      window.addEventListener('pageshow', this.onPageShow);
      this.setupGallery();
      this.update(false);
    }

    /* ---------- options ---------- */
    selectedOptions() {
      var opts = [];
      this.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input[type=radio]:checked');
        opts[parseInt(fs.dataset.optionIndex, 10)] = checked ? checked.value : null;
      });
      return opts;
    }
    findVariant(opts) {
      return this.product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || opts[i] === o; });
      });
    }
    onChange(e) {
      if (e.target.matches('fieldset[data-option-index] input[type=radio]')) this.update(true);
      if (e.target.matches('[name=quantity]')) e.target.value = this.clampQty(parseInt(e.target.value, 10));
      if (e.target.matches('[data-addon], [name=quantity]')) this.updateTotal();
    }
    onClick(e) {
      var step = e.target.closest('[data-step]');
      if (step) {
        var input = step.parentElement.querySelector('input');
        var r = this.qtyRule();
        var cur = parseInt(input.value, 10) || r.min;
        input.value = this.clampQty(cur + parseInt(step.dataset.step, 10) * r.step);
        this.updateTotal();
      }
      var chip = e.target.closest('[data-joint-dim]');
      if (chip) this.pickJoint(chip.dataset.jointDim, chip.dataset.value);
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) this.showMedia(thumb.dataset.thumb, true);
    }
    update(userAction) {
      var opts = this.selectedOptions();
      var variant = this.findVariant(opts);
      this.variant = variant;
      this.markAvailability(opts);
      this.syncJointSplit();
      /* the buttons drop notes like "(clearance)" or "*SPECIAL SIZE", so the exact variant name is spelled out under them */
      var chosen = this.querySelector('[data-joint-chosen]'), jc = this.joints && this.joints.find(function (x) { return x.radio.checked; });
      if (chosen && jc) chosen.textContent = jc.value;
      this.querySelectorAll('[data-selected-label]').forEach(function (el) {
        var fs = el.closest('fieldset'); var c = fs.querySelector('input:checked'); if (c) el.textContent = c.value;
      });

      var idInput = this.querySelector('[data-variant-id]');
      var add = this.querySelector('[data-add]');
      var label = this.querySelector('[data-add-label]');
      if (idInput) idInput.value = variant ? variant.id : '';
      this.applyQtyRule();
      if (add) {
        var ok = variant && variant.available;
        add.disabled = !ok;
        if (label) label.textContent = !variant ? this.strings.unavailable : (ok ? this.strings.addToCart : this.strings.soldOut);
      }
      this.updateTotal();
      if (!userAction || !variant) return;
      if (variant.featured_media) this.showMedia(String(variant.featured_media.id), false);
      if (this.dataset.updateUrl === 'true') {
        var url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
      this.refreshPrice(variant.id);
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }
    refreshPrice(id) {
      var self = this, req = this.priceReq = (this.priceReq || 0) + 1;
      fetch(this.dataset.url + '?variant=' + id + '&section_id=' + this.section)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (req !== self.priceReq) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          self.querySelectorAll('[data-swap="price"]').forEach(function (el) {
            var fresh = doc.querySelector('[data-swap="price"]'); if (fresh) el.innerHTML = fresh.innerHTML;
          });
        }).catch(function () {});
    }
    /* grey out values that can't be combined with the other current picks */
    markAvailability(opts) {
      var variants = this.product.variants;
      this.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.dataset.optionIndex, 10);
        fs.querySelectorAll('input[type=radio]').forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var hit = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] == null || test[i] === o; });
          });
          var lbl = fs.querySelector('label[for="' + input.id + '"]');
          if (lbl) lbl.classList.toggle('is-unavailable', !hit);
        });
      });
    }

    /* ---------- joint picker: one option split into size / type / angle ---------- */
    buildJointSplit() {
      if (!(this.jointIndex >= 0)) return;
      var fs = this.querySelector('fieldset[data-option-index="' + this.jointIndex + '"]');
      if (!fs) return;
      var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type=radio]'));
      var parsed = radios.map(function (r) { return parseJoint(r.value); });
      if (!radios.length || parsed.some(function (p) { return !p; })) return; // values aren't all joints: keep plain chips
      this.joints = radios.map(function (r, i) { return { value: r.value, radio: r, j: parsed[i] }; });

      var holder = fs.querySelector('[data-joint-split]');
      var labels = { size: 'Size', type: 'Joint type', angle: 'Angle' };
      var lang = { size: fs.dataset.labelSize, type: fs.dataset.labelType, angle: fs.dataset.labelAngle, male: fs.dataset.wordMale, female: fs.dataset.wordFemale };
      var self = this, made = 0;
      DIMS.forEach(function (dim) {
        var vals = [];
        self.joints.forEach(function (x) { if (x.j[dim] && vals.indexOf(x.j[dim]) < 0) vals.push(x.j[dim]); });
        if (!vals.length) return;
        if (dim !== 'type') vals.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
        var group = document.createElement('div');
        group.className = 'pm-joint__dim';
        group.setAttribute('role', 'group');
        var gid = self.section + '-jd-' + dim;
        group.setAttribute('aria-labelledby', gid);
        group.innerHTML = '<span class="pm-joint__label" id="' + gid + '">' + (lang[dim] || labels[dim]) + '</span><div class="seg"></div>';
        var seg = group.querySelector('.seg');
        vals.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.jointDim = dim; b.dataset.value = v; b.setAttribute('aria-pressed', 'false');
          b.textContent = dim === 'size' ? v + ' mm' : dim === 'angle' ? v + '°' : (lang[v] || v.charAt(0).toUpperCase() + v.slice(1));
          seg.appendChild(b);
        });
        holder.appendChild(group); made++;
      });
      if (!made) return;
      holder.hidden = false;
      /* the original radios still hold the state, but only the split buttons are shown, focusable and announced */
      fs.querySelector('[data-joint-raw]').hidden = true;
      fs.classList.add('is-split');
    }
    currentJoint() {
      var c = this.joints && this.joints.find(function (x) { return x.radio.checked; });
      return c ? c.j : { size: '', type: '', angle: '' };
    }
    pickJoint(dim, value) {
      var cur = Object.assign({}, this.currentJoint()); cur[dim] = value;
      var self = this, opts = this.selectedOptions();
      function score(x) {               // exact match on the picked dimension, then keep as many others as possible, prefer in stock
        if (x.j[dim] !== value) return -1;
        var s = 0; DIMS.forEach(function (d) { if (d !== dim && x.j[d] === cur[d]) s += 2; });
        var test = opts.slice(); test[self.jointIndex] = x.value;
        var v = self.findVariant(test); if (v && v.available) s += 1;
        return s;
      }
      var best = null, bestScore = -1;
      this.joints.forEach(function (x) { var s = score(x); if (s > bestScore) { bestScore = s; best = x; } });
      if (!best) return;
      best.radio.checked = true;
      this.update(true);
    }
    syncJointSplit() {
      if (!this.joints) return;
      var cur = this.currentJoint(), self = this, opts = this.selectedOptions();
      this.querySelectorAll('[data-joint-dim]').forEach(function (b) {
        var dim = b.dataset.jointDim, val = b.dataset.value;
        b.setAttribute('aria-pressed', cur[dim] === val ? 'true' : 'false');
        // available if some in-stock variant has this value with the other current dimensions
        var ok = self.joints.some(function (x) {
          if (x.j[dim] !== val) return false;
          var others = DIMS.every(function (d) { return d === dim || !cur[d] || x.j[d] === cur[d]; });
          if (!others) return false;
          var test = opts.slice(); test[self.jointIndex] = x.value;
          var v = self.findVariant(test); return v && v.available;
        });
        if (ok) b.removeAttribute('data-unavailable'); else b.setAttribute('data-unavailable', '');
        var label = b.textContent.replace(/ \(.*\)$/, '');
        b.setAttribute('aria-label', ok ? label : label + ' (' + (self.strings.unavailable || 'Unavailable') + ')');
      });
    }

    /* ---------- quantity rules (variant.quantity_rule: min, max, increment) ---------- */
    qtyRule() {
      var r = (this.variant && this.qtyRules && this.qtyRules[this.variant.id]) || {};
      var step = Math.max(1, parseInt(r.step, 10) || 1);
      var min = Math.max(1, parseInt(r.min, 10) || step);
      var max = parseInt(r.max, 10) || null;
      return { min: min, max: max, step: step };
    }
    /* snap to a multiple of the increment, then keep it within min and max */
    clampQty(v) {
      var r = this.qtyRule();
      if (!(v > 0)) v = r.min;
      v = Math.round(v / r.step) * r.step;
      if (v < r.min) v = r.min;
      if (r.max && v > r.max) v = Math.max(r.min, Math.floor(r.max / r.step) * r.step);
      return v;
    }
    applyQtyRule() {
      var input = this.querySelector('[name=quantity]'); if (!input) return;
      var r = this.qtyRule();
      input.min = r.min; input.step = r.step;
      if (r.max) input.max = r.max; else input.removeAttribute('max');
      input.value = this.clampQty(parseInt(input.value, 10));
    }

    /* ---------- totals ---------- */
    updateTotal() {
      var out = this.querySelector('[data-total]'); if (!out || !this.variant) return;
      var q = this.querySelector('[name=quantity]');
      var total = this.variant.price * (q ? parseInt(q.value, 10) || 1 : 1);
      this.querySelectorAll('[data-addon]:checked').forEach(function (c) { total += parseInt(c.dataset.price, 10) || 0; });
      out.textContent = window.HE.money(total);
    }

    /* ---------- gallery ---------- */
    setupGallery() {
      this.slides = this.querySelector('[data-slides]');
      if (!this.slides || !('IntersectionObserver' in window)) return;
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) self.markThumb(en.target.dataset.mediaId);
        });
      }, { root: this.slides, threshold: [0.6] });
      this.slides.querySelectorAll('[data-media-id]').forEach(function (s) { self.io.observe(s); });
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
    }
    markThumb(id) {
      this.querySelectorAll('[data-thumb]').forEach(function (t) {
        if (t.dataset.thumb === id) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    showMedia(id, focus) {
      var slide = this.slides && this.slides.querySelector('[data-media-id="' + id + '"]');
      if (!slide) return;
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slides.scrollTo({ left: slide.offsetLeft - this.slides.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      this.markThumb(id);
      if (focus) slide.setAttribute('tabindex', '-1');
    }

    /* ---------- add to cart ---------- */
    onSubmit(e) {
      /* one add at a time: a double click or a repeated Enter must not add the item twice */
      if (this.adding) { e.preventDefault(); return; }
      var drawer = document.getElementById('CartDrawer');
      var addons = this.querySelectorAll('[data-addon]:checked');
      var useAjax = (window.theme && window.theme.cartType === 'drawer' && drawer) || addons.length;
      if (!useAjax) { this.adding = true; return; } // plain form post to /cart/add; reset by pageshow if the page comes back from the bfcache
      e.preventDefault();
      if (!this.variant || !this.variant.available) return;
      this.adding = true;
      var self = this, btn = this.querySelector('[data-add]'), spin = btn && btn.querySelector('.spinner');
      var err = this.querySelector('[data-error]'), status = this.querySelector('[data-status]');
      var q = this.querySelector('[name=quantity]');
      var items = [{ id: this.variant.id, quantity: q ? parseInt(q.value, 10) || 1 : 1 }];
      addons.forEach(function (c) { items.push({ id: parseInt(c.value, 10), quantity: 1 }); });
      // selling plans and line properties from the form travel with the main item
      var fd = new FormData(this.form), props = {};
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
      if (Object.keys(props).length) items[0].properties = props;
      if (fd.get('selling_plan')) items[0].selling_plan = fd.get('selling_plan');

      /* aria-disabled (not the disabled property) so keyboard focus stays on the button while the request runs */
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('aria-busy', 'true'); if (spin) spin.hidden = false; }
      if (err) err.hidden = true;
      fetch((window.theme.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: (window.HE.cartSections ? window.HE.cartSections() : []).join(','), sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Error');
          return fetch(window.theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, sections: res.body.sections } }));
              if (status) status.textContent = self.strings.added || 'Added to cart';
              if (drawer && window.theme.cartType === 'drawer') document.dispatchEvent(new CustomEvent('cart:open', { detail: { opener: btn } }));
              else location.href = window.theme.routes.cart;
              addons.forEach(function (c) { c.checked = false; }); self.updateTotal();
            });
        })
        .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
        .finally(function () {
          self.adding = false;
          if (btn) { btn.removeAttribute('aria-disabled'); btn.removeAttribute('aria-busy'); if (spin) spin.hidden = true; }
        });
    }
  }
  if (!customElements.get('he-product')) customElements.define('he-product', HeProduct);
  window.HE = window.HE || {}; window.HE.parseJoint = parseJoint;
})();
